import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';
import Button from 'partial/components/Button';
import { useDeleteDomain } from '../hooks';

export const useOpenRemoveDomain = () => {
  const createModal = useCreateModal();

  const openRemoveDomainModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <RemoveDomain data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openRemoveDomainModal;
};

function RemoveDomain({ onClose, data }) {
  const [isLoading, remove] = useDeleteDomain(onClose);
  return (
    <ModalCard size="sm" title="DELETE DOMAIN" onClose={onClose}>
      <div className="p-5 w-full">
        <p className="text-sm font-semibold mb-6">
          Are you sure you want to delete this domain (
          <span className="text-primary">{data?.name}</span>)?
        </p>
        <div className="flex gap-2 justify-end mt-10">
          <Button className="uppercase" onClick={onClose}>
            cancel
          </Button>
          <Button
            disabled={isLoading}
            outline
            className="uppercase"
            onClick={() => remove(data)}
          >
            confirm
          </Button>
        </div>
      </div>
    </ModalCard>
  );
}

RemoveDomain.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RemoveDomain;
